import React, { useState } from "react";
import classnames from "classnames";

import "./pagination.scss";
import { usePagination, DOTS } from "./usePagination";
import { toast } from "react-toastify";

const Pagination = (props) => {
  const {
    onPageChange,
    totalCount,
    siblingCount = 1,
    currentPage,
    pageSize,
    className,
  } = props;

  const paginationRange = usePagination({
    currentPage,
    totalCount,
    siblingCount,
    pageSize,
  });

  const [inputPage, setInputPage] = useState("");

  if (currentPage === 0 || paginationRange.length < 2) {
    return null;
  }

  const lastPage = paginationRange[paginationRange.length - 1];

  const onNext = () => {
    onPageChange(currentPage + 1);
  };

  const onPrevious = () => {
    onPageChange(currentPage - 1);
  };

  const onFastNext = () => {
    onPageChange(lastPage);
  };

  const onFastPrevious = () => {
    onPageChange(1);
  };

  const handleInputChange = (event) => {
    setInputPage(event.target.value);
  };

  const handleInputKeyPress = (event) => {
    if (event.key === "Enter") {
      const pageNumber = parseInt(inputPage, 10);
      if (pageNumber >= 1 && pageNumber <= lastPage) {
        onPageChange(pageNumber);
      }else{
        toast.warn(`Entered Page ${pageNumber} is not valid`)
        console.log('enter coreect page')
      }
    }
  };

  return (
    <div
      className={classnames("pagination-wrapper", { [className]: className })}
    >
   
      <ul className="pagination-container">
      <input
        type="number"
        value={inputPage}
        onChange={handleInputChange}
        onKeyDown={handleInputKeyPress}
        placeholder="Page"
        className="pagination-input"
      />
        <li
          className={classnames("pagination-item", {
            disabled: currentPage === 1,
          })}
          onClick={onFastPrevious}
        >
          <div className="arrow left" />
          <div className="arrow left" />
        </li>
        <li
          className={classnames("pagination-item", {
            disabled: currentPage === 1,
          })}
          onClick={onPrevious}
        >
          <div className="arrow left" />
        </li>
        {paginationRange.map((pageNumber) => {
          if (pageNumber === DOTS) {
            return <li className="pagination-item dots">&#8230;</li>;
          }

          return (
            <li
              key={pageNumber}
              className={classnames("pagination-item", {
                selected: pageNumber === currentPage,
              })}
              onClick={() => onPageChange(pageNumber)}
            >
              {pageNumber}
            </li>
          );
        })}
        <li
          className={classnames("pagination-item", {
            disabled: currentPage === lastPage,
          })}
          onClick={onNext}
        >
          <div className="arrow right" />
        </li>
        <li
          className={classnames("pagination-item", {
            disabled: currentPage === lastPage,
          })}
          onClick={onFastNext}
        >
          <div className="arrow right" />
          <div className="arrow right" />
        </li>
      </ul>
    </div>
  );
};

export default Pagination;
